import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lg:flex lg:space-x-8 space-y-4 lg:space-y-0 print:flex print:space-x-2 print:space-y-0" }
const _hoisted_2 = { class: "lg:flex lg:space-x-8 space-y-4 lg:space-y-0 print:flex print:space-x-2 print:space-y-0" }
const _hoisted_3 = { class: "flex flex-col space-y-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold" }, "Vælg periode", -1)
const _hoisted_5 = { class: "flex flex-col space-y-2" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-semibold opacity-80" }, "Fra", -1)
const _hoisted_7 = { class: "flex flex-col space-y-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "text-sm font-semibold opacity-80" }, "Til", -1)
const _hoisted_9 = { class: "flex justify-end space-x-3 pt-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomSelect = _resolveComponent("CustomSelect")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([[{ 'fixed top-0 left-0 right-0 z-50 py-4 px-10 bg-white shadow-md': _ctx.sticky }], "screen:lg:flex lg:justify-between lg:space-x-8 space-y-4 lg:space-y-0 print:space-x-y"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_CustomSelect, {
        value: _ctx.selectedRegion,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRegion) = $event)),
        class: "min-w-56",
        label: "Alle kommuner",
        items: _ctx.selectableRegions,
        "item-text": "title",
        "item-value": "id"
      }, null, 8, ["value", "items"]),
      (_ctx.includeCourses)
        ? (_openBlock(), _createBlock(_component_CustomSelect, {
            key: 0,
            value: _ctx.selectedCourse,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCourse) = $event)),
            class: "min-w-56",
            label: "Forløb",
            items: _ctx.courses,
            "item-text": "title",
            "item-value": "id"
          }, null, 8, ["value", "items"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CustomSelect, {
        value: _ctx.selectedGender,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedGender) = $event)),
        class: "w-48",
        label: "Køn",
        items: _ctx.gendersWithTranslations,
        "item-text": "translatedText",
        "item-value": "id"
      }, null, 8, ["value", "items"]),
      _createVNode(_component_CustomSelect, {
        value: _ctx.selectedAgeRange,
        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.selectedAgeRange) = $event)),
        class: "w-56",
        label: "Aldersgruppe",
        items: _ctx.ageRanges,
        "item-text": "title",
        "item-value": "id"
      }, null, 8, ["value", "items"]),
      _createVNode(_component_CustomSelect, {
        value: _ctx.selectedPeriod,
        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedPeriod) = $event)),
        class: "w-56",
        label: "Periode",
        items: _ctx.timePeriods,
        "item-text": "text",
        "item-value": "id"
      }, null, 8, ["value", "items"]),
      _createVNode(_component_Modal, {
        ref: "customRangeModal",
        "close-button": "",
        size: "w-120",
        padding: "px-6 py-4",
        onClose: _ctx.onModalClose
      }, {
        body: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.tempCustomFrom) = $event)),
                type: "date",
                class: "h-12 px-3 border border-gray-400 rounded-md"
              }, null, 512), [
                [_vModelText, _ctx.tempCustomFrom]
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.tempCustomTo) = $event)),
                type: "date",
                class: "h-12 px-3 border border-gray-400 rounded-md"
              }, null, 512), [
                [_vModelText, _ctx.tempCustomTo]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("button", {
                type: "button",
                class: "px-4 py-2 border border-gray-400 rounded-md",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.cancelCustomRange && _ctx.cancelCustomRange(...args)))
              }, "Annuller"),
              _createElementVNode("button", {
                type: "button",
                class: "px-4 py-2 !bg-black text-white rounded-md",
                onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.applyCustomRange && _ctx.applyCustomRange(...args)))
              }, "Gem")
            ])
          ])
        ]),
        _: 1
      }, 8, ["onClose"])
    ])
  ], 2))
}